import { NgModule, CSP_NONCE } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './no-auth/login/login.component';
import { ForgotPasswordComponent } from './no-auth/forgot-password/forgot-password.component';
import { NgbModule, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry } from 'ag-grid-community';
import { AllCommunityModule } from 'ag-grid-community';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { jwtInterceptor } from './shared/helpers/jwt.interceptor';
import { errorInterceptor } from './shared/helpers/error.interceptor';
import { LayoutComponent } from './auth/layout/layout.component';
import { TransactionsComponent } from './auth/transactions/transactions.component';
import { UsersComponent } from './auth/users/users.component';
import { NewUserComponent } from './auth/users/new-user/new-user.component';
import { ReconciliationComponent } from './auth/reconciliation/reconciliation.component';
import { CountryComponent } from './auth/country/country.component';
import { CurrencyComponent } from './auth/currency/currency.component';
import { ViewImageComponent } from './shared/components/view-image/view-image.component';
import { CustomersComponent } from './auth/customers/customers.component';
import { CustomerDetailsComponent } from './auth/customers/customer-details/customer-details.component';
import { BeneficiaryTransactionsComponent } from './auth/customers/beneficiary-transactions/beneficiary-transactions.component';
import { RateConversionComponent } from './auth/rate-conversion/rate-conversion.component';
import { LedgersComponent } from './auth/ledgers/ledgers.component';
import { DateFilterComponent } from './shared/components/date-filter/date-filter.component';
import { DashboardComponent } from './auth/dashboard/dashboard.component';
import { RiskComponent } from './auth/dashboard/risk/risk.component';
import { OpsComponent } from './auth/dashboard/ops/ops.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CustomAdapter, CustomDateParserFormatter } from './shared/pipes/date.formatter';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SecurityQuestionsComponent } from './auth/settings/security-questions/security-questions.component';
import { MfaComponent } from './auth/settings/mfa/mfa.component';
import { MfaLoginComponent } from './no-auth/mfa-login/mfa-login.component';
import { DateFilterNewComponent } from './shared/components/date-filter-new/date-filter-new.component';
import { BeneficiariesComponent } from './auth/beneficiaries/beneficiaries.component';
import { SettlementComponent } from './auth/settlement/settlement.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    LayoutComponent,
    TransactionsComponent,
    UsersComponent,
    NewUserComponent,
    ReconciliationComponent,
    RateConversionComponent,
    CountryComponent,
    CurrencyComponent,
    ViewImageComponent,
    CustomersComponent,
    CustomerDetailsComponent,
    BeneficiaryTransactionsComponent,
    LedgersComponent,
    DateFilterComponent,
    DashboardComponent,
    RiskComponent,
    OpsComponent,
    ResetPasswordComponent,
    SecurityQuestionsComponent,
    MfaComponent,
    MfaLoginComponent,
    DateFilterNewComponent,
    BeneficiariesComponent,
    SettlementComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    AgGridModule,
    FormsModule,
    HttpClientModule,
    NgxChartsModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([jwtInterceptor, errorInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    {
      provide: CSP_NONCE,
      useFactory: () => {
        const el = document.querySelector('meta[name="csp-nonce"]');
        const val = el?.getAttribute('content');
        return val && val !== '__CSP_NONCE__' ? val : '';
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    // Register the AG Grid modules globally
    ModuleRegistry.registerModules([AllCommunityModule]); // Register all community modules
  }
}